import React from "react";
import {
    Module,
    PermissionItem,
    PermissionTitle,
} from "../../styles";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";
import { ReactComponent as UnCheckIcon } from "../../assets/icons/uncheck.svg";

import { removeHyphensAndDashes, titleCase } from "../../utils/capitalizeName";


interface PermissionsProps {
    module: string;
    permissions?: string[];
}

const RolePermissionList: React.FC<PermissionsProps> = ({
    module,
    permissions,
}) => {


    return (
        <div>
            <Module>{removeHyphensAndDashes(module)}</Module>
            {permissions?.map((permission) => {
                const formattedTitle = titleCase(
                    permission.toLowerCase().replace(/_/g, " ")
                );

                const isChecked = true;

                return (
                    <div key={permission}>
                        <PermissionItem>
                            <PermissionTitle>{formattedTitle}</PermissionTitle>
                            {isChecked ? <CheckIcon /> : <UnCheckIcon />}
                        </PermissionItem>
                    </div>
                );
            })}


        </div>
    );
};

export default RolePermissionList;
